﻿$.fn.dxCtrlFichier2VisuSvg = function custom_dxCtrlFichier2VisuSvg(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2visusvg");
        this.instance = new cdxCtrlFichier2VisuSvg(this, option);
    }
    return this;
}

window.cdxCtrlFichier2VisuSvg = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty();
        container.css({
            "height": "100%",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center"
        })

        var urlFile = option.itemData.url
        if (urlFile.startsWith("~")) urlFile = urlFile.substring(1)
        $("<img src='" + urlFile + "' style='width:100%;'/>").appendTo(container)
    }

    this.element = function () { return container }

    mConstruit();
}